export enum AnalysisDataValue {
  True = "true",
  False = "false",
  MissingData = "Missing data",
}
